// @ts-nocheck


import React from 'react';
import { navigate } from '../../lib/routerAdapter';
import notification from 'antd/lib/notification';

import styled from 'styled-components';
import Button from 'antd/lib/button';

import orderBy from 'lodash/orderBy';
import difference from 'lodash/difference';

import Breadcrumbs, { Crumb } from '../../components/layout/Breadcrumbs';
import { Header, Section } from './../../components/layout';
import { vehicleIssueApi, fileApi } from './../../lib/api';

import { Form } from './../../components';
import { validateFile } from './../../lib/helpers';
import { notificationLoading } from './../../components/Notifications';
import CancelButton from './../../components/CancelButton';
import Uploader from './components/Uploader';

const StyledSection = styled(Section).withConfig({ displayName: "MaintenanceFiles__StyledSection", componentId: "sc-50ill5-0" })(["padding:16px 0;"]);


const SectionContent = styled.div.withConfig({ displayName: "MaintenanceFiles__SectionContent", componentId: "sc-50ill5-1" })(["padding:0 16px;"]);


const Footer = styled(Section).withConfig({ displayName: "MaintenanceFiles__Footer", componentId: "sc-50ill5-2" })(["padding:16px;display:flex;justify-content:space-between;align-items:center;"]);

















class Files extends React.Component {
  state = {
    previewVisible: false,
    previewFile: {},
    vehicleIssue: {}
  };

  async componentDidMount() {
    const { vehicleIssueId } = this.props;
    const vehicleIssue = await vehicleIssueApi.getVehicleIssue(vehicleIssueId);
    this.setState({ vehicleIssue });
  }

  onSubmit = async (values) => {
    const { vehicleIssue } = this.state;
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      // $FlowFixMe flow тупит
      await vehicleIssueApi.updateVehicleIssue({ ...vehicleIssue, ...values });
      if (values.files.length < vehicleIssue.files.length) {
        this.handleCancel(values.files);
      }
      navigate(`/maintenances/journal/${vehicleIssue.maintenanceId}`);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  handleCancel = (files) => {
    const { vehicleIssue } = this.state;
    difference(
      files.map((file) => file.id),
      vehicleIssue.files.map((file) => file.id)
    ).forEach((id) => fileApi.deleteFile(id));
    navigate(`/maintenances/journal/${vehicleIssue.maintenanceId}`);
  };

  handlePreview = (file) => {
    this.setState({
      previewFile: file,
      previewVisible: true
    });
  };

  beforeUpload = function (file) {
    const validFileType = validateFile(file.type, this.props.tag);
    if (!validFileType) {
      notification.error({
        message: 'Загружать можно только изображения и PDF!'
      });
    }
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      notification.error({ message: 'Файл должен быть менее 10MB!' });
    }
    return validFileType && isLt2M;
  };

  handleClose = () => this.setState({ previewVisible: false, previewFile: {} });

  render() {
    const { tag } = this.props;
    const { vehicleIssue } = this.state;
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Транспорт</Crumb>
              <Crumb to="/maintenances/journal">Ремонт</Crumb>
              <Crumb to={`/maintenances/journal/${vehicleIssue.maintenanceId}`}>
                Ремонт №{vehicleIssue.maintenanceId}
              </Crumb>
              <Crumb>Добавление файла</Crumb>
            </Breadcrumbs>
          } />

        <Form initialValues={vehicleIssue || {}} onSubmit={this.onSubmit}>
          {(FormField, formikProps) => {
            const { handleSubmit, setFieldValue, dirty, values } = formikProps;
            return (
              <form onSubmit={handleSubmit}>
                <StyledSection>
                  <SectionContent>
                    <FormField label="Файлы" required name="files">
                      {({ value, name }) =>
                      <Uploader
                        value={orderBy(value, 'createdTime', ['desc'])}
                        multiple
                        tag={tag}
                        onChange={(files) => setFieldValue(name, files)}
                        previewFile />

                      }
                    </FormField>
                  </SectionContent>
                </StyledSection>
                <Footer>
                  <Button type="primary" htmlType="submit">
                    Сохранить
                  </Button>
                  <CancelButton
                    dirty={dirty}
                    onClick={() => this.handleCancel(values.files)}>

                    Отменить
                  </CancelButton>
                </Footer>
              </form>);

          }}
        </Form>
      </>);

  }
}

export default Files;
